export default __webpack_public_path__ + "static/media/actividad-34.81ffd2e8.mp3";